import { ActivatedRouteSnapshot } from "@angular/router";

export abstract class EntityResolver {
  abstract resolve(route: ActivatedRouteSnapshot);
}
